<template>


    <div class="main-container">
        <div class="main-header container">
            <ainak-header/>
        </div>
        <div class="main-content container">
            <div class="api-container">
                <a target="_blank" href="https://docs.google.com/document/d/1tczc1xG-sOPL-NKQXDPE2kepSc3Ov7n1xY-1OPHCBYk/edit?usp=sharing"> API calls list </a>
            </div>
        </div>
        <div class="main-footer ">
            <ainak-footer/>
        </div>
    </div>
</template>

<script>
    import AinakFooter from "@/components/AinakFooter.vue";
    import AinakHeader from "@/components/AinakHeader.vue";
    export default {
        name: "Apis",
        components: {
            AinakHeader,
            AinakFooter
        },
    }
</script>
<style  lang="scss" scoped>
    @import "@/assets/css/colors.scss";

    %top-padding-width-height {
        width: 100%;
        height: 100%;
        top: 0;
    }
    %flex-center-content {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .main-container {
        @extend %top-padding-width-height;
        display: grid;
        grid-template-areas: "main-header" "main-content" "main-footer";
        grid-template-rows: 10% 85% 5%;
        grid-template-columns: 1fr;
        overflow: hidden;
        margin:  0;

        .main-header {
            @extend %flex-center-content;
        }

        .main-content {
            grid-area: main-content;
            background-color: $bg-color;
            @extend %top-padding-width-height;
            overflow: hidden;
        }

        .main-footer{
            grid-area: main-footer;
            display: flex;
            justify-content: center;
            flex-direction: column;
            background-color: #f5f5f5;
        }

        .api-container{
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            align-content: center;

            a{
                font-family: 'Roboto Slab', sans-serif;
                font-size: 200%;
                width: 100%;
                margin: 0 0 2% 0;
                color: $primary-color;
            }
        }
    }

</style>
<!--<style lang="scss" scoped>-->

    <!--$primary-color: #7657ec;-->



<!--</style>-->